import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthProvider";
import Navbar from "@/components/Navbar";


function Dashboard() {
  const auth = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!auth?.token) navigate('/login')
  }, [auth?.token, navigate])

  if (!auth?.token) return null

  const parts = auth?.token.split('.');
  const payload = JSON.parse(atob(parts[1]!));

  return (
    <>
      <motion.div
        initial={{ scale: 0.88, opacity: 0, y: 16 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.94, opacity: 0, y: -8, transition: { duration: 0.1 } }}
        transition={{ type: "spring", stiffness: 700, damping: 25 }}
        className="page_centered"
      >

        <h2 className="relative">
          { payload.username }
        </h2>
        <p className="text-black/60">Here you'll find the betas to test the app.</p>

      </motion.div>
    </>
  )
}

export default Dashboard
